import { render, staticRenderFns } from "./PCNavigate.vue?vue&type=template&id=167ae530&scoped=true"
import script from "./PCNavigate.vue?vue&type=script&lang=js"
export * from "./PCNavigate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167ae530",
  null
  
)

export default component.exports